import React, { useState, useEffect, useRef } from "react";
import { Col, Form, Row, Tabs, Tab } from "react-bootstrap";
import { Select, DatePicker } from "antd";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import Table from "../../Components/TableTemplate/Table";
import {
  formatDateNoTime,
  formatDate,
  getRole,
  numberFormat,
  numberWithCommas,
  formatDateSeconds,
  refreshPage,
  dateFormat,
  toastStyle,
  formatPrice,
  // getRestoLogin,
} from "../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import { DownloadTableExcel } from "react-export-table-to-excel";
import ExportPDF from "../../Components/Export/ExportPDF";
import { useReactToPrint } from "react-to-print";
import PrintReportReceipts from "../../Components/Print/PrintReportReceipts";
import Pdf from "react-to-pdf";
import moment from "moment";
import PrintHourly from "../../Components/Print/PrintHourly";
import NoDataImg from "../../Assets/Images/no-data-img.png";
import html2canvas from "html2canvas";
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI";
import MytFooter from "../../Components/MytFooter";

const { RangePicker } = DatePicker;
// const ref = React.createRef();
// const ref2 = React.createRef();

function Sales() {
  const dateToday = moment().format("YYYY-MM-DD");
  // const [restoType, setRestoType] = useState(getRestoLogin());
  const [inactive, setInactive] = useState(true);
  const [sales, setSales] = useState([]);
  const [salesDaily, setSalesDaily] = useState([]);
  const [hourlyData, setHourlyData] = useState([]);
  const [monthlySales, setMonthlySales] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [overAllSales, setOverAllSales] = useState(0);
  const [overVatSales, setOverVatSales] = useState(0);
  const [overAllTotalSales, setOverAllTotalSales] = useState(0);
  const [totalVat, setTotalVat] = useState(0);
  const [overZeroRatedSales, setOverZeroRatedSales] = useState(0);
  const [overVatExemptSales, setOverVatExemptSales] = useState(0);
  const [overExemptionSales, setOverExemptionSales] = useState(0);
  const [pwdDiscountData, setPwdDiscountData] = useState(0);
  const [seniorDiscountData, setSeniorDiscountData] = useState(0);
  const [otherDiscountData, setOtherDiscountData] = useState(0);
  const [pwdDiscountDataMonthly, setPwdDiscountDataMonthly] = useState(0);
  const [seniorDiscountDataMonthly, setSeniorDiscountDataMonthly] = useState(0);
  const [otherDiscountDataMonthly, setOtherDiscountDataMonthly] = useState(0);
  const [totalDiscountData, setTotalDiscountData] = useState(0);
  const [monthlyTransactionNo, setMonthlyTransactionNo] = useState(0);
  const [dailyTransactionNo, setDailyTransactionNo] = useState(0);
  const [filterMonthly, setFilterMonthly] = useState({
    month: moment().format("YYYY-MM"),
  });
  const [totalHourly, setTotalHourly] = useState(0);
  const [filter, setFilter] = useState({
    type: "",
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
  });
  const componentRef = useRef();
  const componentRefMonthly = useRef();
  const [readyExport, setReadyExport] = useState(false);
  const [exportData, setExportData] = useState([]);

  const headers = [
    "DATE",
    "SI. FROM",
    "SI. TO",
    "NET VATABLE SALES",
    "VAT EXEMPT SALES",
    "ZERO-RATED",
    "GROSS VAT SALES",
    "TOTAL VAT",
    "NET VAT",
    "PWD DISC.",
    "SENIOR DISC.",
    "OTHER DISC.",
    "TOTAL DISC.",
    "VAT EXEMPT",
    "TOTAL TAX",
    "GRAND TOTAL",
  ];
  const headers2 = [
    "DATE",
    "NET VATABLE SALES",
    "VAT EXEMPT SALES",
    "ZERO-RATED",
    "GROSS VAT SALES",
    "TOTAL VAT",
    "PWD DISC.",
    "SENIOR DISC.",
    "OTHER DISC.",
    "TOTAL DISC.",
    "VAT EXEMPT",
    "TOTAL TAX",
    "GRAND TOTAL",
  ];

  async function fetchSales() {
    setShowLoader(true);
    // const response = await getSales(
    // filter.type,
    // filter.date_from,
    // filter.date_to
    // );
    const response = await UseGetRequest("orders/getSales", filter, 
      // restoType
    );
    if (response.data) {
      setDailyTransactionNo(response.data.message.total_transaction);

      const arr = response.data.message.datas.map((data) => {
        return {
          sales_date: formatDateNoTime(data.sales_date),
          vat_sales: formatPrice(data.vat_sales),
          vat_exempt: formatPrice(data.vat_exempt),
          zero_rated: formatPrice(data.zero_rated),
          total_sales: formatPrice(data.total_sales),
          vat_amount: formatPrice(data.vat_amount),
          pwd_discount: formatPrice(data.pwd_discount),
          senior_discount: formatPrice(data.senior_discount),
          other_discount: formatPrice(data.other_discount),
          discount: formatPrice(data.discount),
          vat_exemption: formatPrice(data.vat_exemption),
          total_tax: formatPrice(data.total_tax),
          total_amount: formatPrice(data.total_amount),
        };
      });
      const exportInfo = response.data.message.datas.map((info) => {
        return {
          payment_type: info.payment_type,
          sales_date: formatDateNoTime(info.sales_date),
          total_sales: info.total_sales,
        };
      });
      setOverAllSales(
        response.data.message.datas
          .map((data) => parseFloat(data.total_amount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setOverVatSales(
        response.data.message.datas
          .map((data) => parseFloat(data.vat_sales))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setOverVatExemptSales(
        response.data.message.datas
          .map((data) => parseFloat(data.vat_exempt))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setOverZeroRatedSales(
        response.data.message.datas
          .map((data) => parseFloat(data.zero_rated))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setOverAllTotalSales(
        response.data.message.datas
          .map((data) => parseFloat(data.total_sales))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setTotalVat(
        response.data.message.datas
          .map((data) => parseFloat(data.vat_amount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setTotalDiscountData(
        response.data.message.datas
          .map((data) => parseFloat(data.discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setOverExemptionSales(
        response.data.message.datas
          .map((data) => parseFloat(data.vat_exemption))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setPwdDiscountData(
        response.data.message.datas
          .map((data) => parseFloat(data.pwd_discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setSeniorDiscountData(
        response.data.message.datas
          .map((data) => parseFloat(data.senior_discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setOtherDiscountData(
        response.data.message.datas
          .map((data) => parseFloat(data.other_discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setExportData(exportInfo.length === 0 ? [] : exportInfo);
      setReadyExport(true);
      setSales(arr);
      setSalesDaily(response.data.message.daily_sales);
      setShowLoader(false);
    } else {
      setOverAllSales(0)
      setDailyTransactionNo(0);
      setSales([]);
      setShowLoader(false);
    }
  }

  async function fetchMonthlySales() {
    setShowLoader(true);
    // const response = await getMonthlySales(filterMonthly.month);
    const response = await UseGetRequest(
      "reports/getMonthlySales",
      { month: filterMonthly.month },
      // restoType
    );
    if (response.data) {
      setMonthlyTransactionNo(response.data.message.total_transaction);
      const arr = response.data.message.datas.map((data) => {
        return {
          // ...data,
          sales_date: formatDateNoTime(data.sales_date),
          or_from: data.or_from,
          or_to: data.or_to,
          total_vat_sales: formatPrice(data.total_vat_sales),
          total_vat_exempt_sales: formatPrice(data.total_vat_exempt_sales),
          total_zero_rated_sales: formatPrice(data.total_zero_rated_sales),
          total_sales: formatPrice(data.total_sales),
          total_vat: formatPrice(data.total_vat),
          net_vat: formatPrice(data.net_vat) || 0.00,
          pwd_discount: formatPrice(data.pwd_discount),
          senior_discount: formatPrice(data.senior_discount),
          other_discount: formatPrice(data.other_discount),
          total_discount: formatPrice(data.total_discount),
          total_vat_exemption: formatPrice(data.total_vat_exemption),
          total_tax: formatPrice(data.total_tax),
          grand_total: formatPrice(data.grand_total),
        };
      });
      // arr.push({ ...data,  })
      const exportInfo = response.data.message.datas.map((info) => {
        return {
          payment_type: info.payment_type,
          sales_date: formatDateNoTime(info.sales_date),
          total_sales: info.total_sales,
        };
      });
      setMonthlyGrandTotal(
        response.data.message.datas
          .map((data) => parseFloat(data.grand_total))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setMonthlyTotalVat(
        response.data.message.datas
          .map((data) => parseFloat(data.total_vat_sales))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setMonthlyTotalVatExempt(
        response.data.message.datas
          .map((data) => parseFloat(data.total_vat_exempt_sales))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setMonthlyTotalZeroRated(
        response.data.message.datas
          .map((data) => parseFloat(data.total_zero_rated_sales))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setMonthlyTotalSales(
        response.data.message.datas
          .map((data) => parseFloat(data.total_sales))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setMonthlyVat(
        response.data.message.datas
          .map((data) => parseFloat(data.total_vat))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setMonthlyNetVat(
        response.data.message.datas
          .map((data) => parseFloat(data.net_vat))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setMonthlyDiscount(
        response.data.message.datas
          .map((data) => parseFloat(data.total_discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setMonthlyExemption(
        response.data.message.datas
          .map((data) => parseFloat(data.total_vat_exemption))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setPwdDiscountDataMonthly(
        response.data.message.datas
          .map((data) => parseFloat(data.pwd_discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setSeniorDiscountDataMonthly(
        response.data.message.datas
          .map((data) => parseFloat(data.senior_discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setOtherDiscountDataMonthly(
        response.data.message.datas
          .map((data) => parseFloat(data.other_discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setExportData(exportInfo.length === 0 ? [] : exportInfo);
      setReadyExport(true);
      setMonthlySales(arr);
    } else {
      setMonthlyTransactionNo(0);
      setMonthlyGrandTotal(0);
      setMonthlyTotalVat(0);
      setMonthlyTotalVatExempt(0);
      setMonthlyTotalZeroRated(0);
      setMonthlyTotalSales(0);
      setMonthlyVat(0);
      setMonthlyDiscount(0);
      setMonthlyExemption(0);
      setPwdDiscountDataMonthly(0);
      setSeniorDiscountDataMonthly(0);
      setOtherDiscountDataMonthly(0);
      setExportData([]);
      setReadyExport(false);
      setMonthlySales([]);
    }
    setShowLoader(false);
  }

  const [monthlyGrandTotal, setMonthlyGrandTotal] = useState(0);
  const [monthlyTotalVat, setMonthlyTotalVat] = useState(0);
  const [monthlyTotalVatExempt, setMonthlyTotalVatExempt] = useState(0);
  const [monthlyTotalZeroRated, setMonthlyTotalZeroRated] = useState(0);
  const [monthlyTotalSales, setMonthlyTotalSales] = useState(0);
  const [monthlyVat, setMonthlyVat] = useState(0);
  const [monthlyNetVat, setMonthlyNetVat] = useState(0);
  const [monthlyDiscount, setMonthlyDiscount] = useState(0);
  const [monthlyExemption, setMonthlyExemption] = useState(0);
  const [hourlyDate, setHourlyDate] = useState(new Date().toLocaleDateString("en-CA"));

  async function fetchHourly() {
    // const response = await getDailySales();
    const response = await UseGetRequest("reports/hourly", {date: hourlyDate}, 
      // restoType
    );
    if (response.data) {
      setHourlyData(response.data.data.sales);
      setTotalHourly(
        response.data.data.sales
          .map((data) => parseFloat(data.total_amount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
    } else {
      setHourlyData([]);
      setTotalHourly(0);
    }
  }

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  const handleFilterMonthly = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filterMonthly };
    filtercopy[name] = value;
    setFilterMonthly(filtercopy);
  };

  /** EXPORT */
  function handleToCSV() {
    return (
      <DownloadTableExcel
        filename="Daily Report Summary"
        sheet="users"
        currentTableRef={componentRef.current}
      >
        <button className="category-new-export-btn">Export CSV</button>
      </DownloadTableExcel>
    );
  }

  function handleToCSVMonthly() {
    return (
      <DownloadTableExcel
        filename="Monthly Report Summary"
        sheet="users"
        currentTableRef={componentRefMonthly.current}
      >
        <button className="category-new-export-btn">Export CSV</button>
      </DownloadTableExcel>
    );
  }

  function handleToCSVHourly() {
    return (
      <DownloadTableExcel
        filename="Hourly Report Summary"
        sheet="users"
        currentTableRef={componentRefHourly.current}
      >
        <button className="category-new-export-btn">Export CSV</button>
      </DownloadTableExcel>
    );
  }

  const componentRefHourly = useRef();
  // const handlePrintHourlyReport = useReactToPrint({
  //   content: () => componentRefHourly.current,
  //   pageStyle: () => "@page { size: letter; margin: 5mm; }",
  // });

  const componentRefSummary = useRef();
  const handlePrintReport = useReactToPrint({
    content: () => componentRefSummary.current,
    pageStyle: () => "@page { size: letter; margin: 5mm; }",
  });

  function handlePDF() {
    return (
      <ExportPDF
        name={
          selectMonthly === "monthly"
            ? "Monthly Sales"
            : selectMonthly === "daily"
            ? "Daily Sales"
            : "Hourly Sales"
        }
        date={selectMonthly === "monthly" ? filterMonthly : filter}
        data={
          selectMonthly === "monthly"
            ? monthlySales
            : selectMonthly === "daily"
            ? sales
            : hourlyData
        }
        header={
          selectMonthly === "monthly"
            ? headers
            : selectMonthly === "daily"
            ? headers2
            : ["TIME", "TOTAL SALES"]
        }
        report={
          selectMonthly === "monthly"
            ? "monthly"
            : selectMonthly === "daily"
            ? "daily"
            : "hourly"
        }
      >
        <Pdf
          // targetRef={exportData ? ref2 : ref}
          filename={"officialReceipt_" + formatDate(new Date()) + ".pdf"}
          style={{ height: "100%", width: "100%" }}
        >
          {({ toPdf }) => (
            <button
              className="category-new-export-btn me-1 w-100"
              onClick={handlePrintReport}
            >
              Export PDF
            </button>
          )}
        </Pdf>
      </ExportPDF>
    );
  }

  const [selectMonthly, setSelectMonthly] = useState("monthly");

  const handleTabSelect = (tabKey) => {
    setSelectMonthly(tabKey);
    if (tabKey === "monthly") {
      fetchMonthlySales();
    } else if (tabKey === "daily") {
      fetchSales();
    } else if (tabKey === "hourly") {
      fetchHourly();
    }
  };

  const divId = useRef(null);
  const [allowPrint, setAllowPrint] = useState(false);
  const handlePrint = () => {
    setAllowPrint(true);
  };
  const handlePrintgenerate = () => {
    setAllowPrint(true);
    if (divId.current) {
      const element = divId.current;

      // element.style.width = "38%";
      // element.style.height = "100%";

      html2canvas(element, { scale: 1 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        printBase64Data(imgData);
        toast.success("Processing...", {
          style: toastStyle(),
        });
      });
    }
  };

  async function printBase64Data(image) {
    const response = await printBase64(
      window.printer_name,
      image,
      "0",
      // restoType
    );
    if (response.data) {
      refreshPage();
    } else {
    }
  }

  useEffect(() => {
    if (allowPrint) {
      handlePrintgenerate();
    }
  }, [allowPrint]);

  useEffect(() => {
    fetchMonthlySales();
  }, [filterMonthly.month]);

  useEffect(() => {
    fetchSales();
  }, [filter]);

  useEffect(() => {
    fetchSales();
    fetchMonthlySales();
  }, [
    // restoType
  ]);

  useEffect(() => {
    fetchHourly();
  }, [
    // restoType, 
    hourlyDate
  ]);

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"}
        page={"Reports"}
      />
      <div
        className={`container ps-5 pt-4 bold-font ${inactive ? "inactive" : "active"}`}
      >
        <Row className="mb-3">
          <Col>
            <h1 className="page-title-menu pt-2"> SALES REPORT </h1>
          </Col>
          <Col className="d-flex justify-content-end mb-2">
            {selectMonthly === "hourly" && (
              <>
                {readyExport && <Col className="me-1" xs={4}>{handlePDF()}</Col>}
                {readyExport && <Col xs={4}>{handleToCSVHourly()}</Col>}
              </>
            )}
            {selectMonthly === "monthly" && (
              <>
                <Col xs={3} className="me-1">
                  <button
                    onClick={handlePrint}
                    className="category-new-export-btn"
                  >
                    Print
                  </button>
                </Col>
                {readyExport && (
                  <Col xs={4} className="me-1">
                    {handlePDF()}
                  </Col>
                )}
                {readyExport && <Col xs={4}>{handleToCSVMonthly()}</Col>}
              </>
            )}
            {selectMonthly === "daily" && (
              <>
                <Col xs={3} className="me-1">
                  <button
                    onClick={handlePrint}
                    className="category-new-export-btn"
                  >
                    Print
                  </button>
                </Col>
                {readyExport && <Col className="me-1" xs={4}>{handlePDF()}</Col>}
                {readyExport && <Col xs={4}>{handleToCSV()}</Col>}
              </>
            )}
          </Col>
        </Row>
        <hr />
        <Row>
          <Tabs
            defaultActiveKey="monthly"
            transition={false}
            id="noanim-tab-example"
            className="tabs-order-update"
            onSelect={handleTabSelect}
          >
            <Tab eventKey="hourly" title="hourly">
              <Row className=" p-5 pt-2">
                <Col>
                  <Row className="my-2 PO-filters d-flex">
                    {/* <Col xs={3}> */}
                    <Form.Control
                          size="sm"
                          type="date"
                          className="date-filter me-3"
                          onChange={(e)=>setHourlyDate(e.target.value)}
                          value={hourlyDate}
                        />
                    {/* </Col> */}
                    {/* <Col xs={3}>
                      <Select
                        placeholder="Select restaurant"
                        options={[
                          { value: "", label: "All" },
                          { value: "hanamaruken", label: "hanamaruken" },
                          { value: "ettas", label: "ETTAS" },
                        ]}
                        onChange={(e) => setRestoType(e)}
                        defaultValue={restoType}
                      />
                    </Col> */}
                  </Row>
                  <Row className="pt-4">
                    <Col className="d-flex justify-content-left">
                      <label>
                        <strong>Time</strong>
                      </label>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <label>
                        <strong>Total Sales</strong>
                      </label>
                    </Col>
                    <hr />
                  </Row>
                  {totalHourly > 0 ? (
                    hourlyData.map((data) => {
                      return (
                        <Row>
                          <Col>
                            <label>{data.HourRange}</label>
                          </Col>
                          <Col className="d-flex justify-content-end">
                            <label>{data.total_amount}</label>
                          </Col>
                        </Row>
                      );
                    })
                  ) : (
                    <div className="no-data-cont">
                      <img src={NoDataImg} alt="no data found" />
                      <span>Uh Oh! No data found.</span>
                    </div>
                  )}
                  {hourlyData.length > 0 && (
                    <Row>
                      <hr />
                      <Col className="d-flex justify-content-start">
                        <label>
                          <strong>GRAND TOTAL : </strong>
                        </label>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <label>
                          <strong>
                            {numberWithCommas(
                              hourlyData
                                .map((item) => parseFloat(item.total_amount))
                                .reduce((a, b) => a + b, 0)
                                .toFixed(2)
                            )}
                          </strong>
                        </label>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="monthly" title="monthly">
              <div>
                <Row className="my-1 mb-3">
                  <div className="my-2 px-4 PO-filters d-flex">
                    {getRole() !== 2 && (
                      <>
                        <Form.Control
                          size="sm"
                          type="month"
                          name="month"
                          className="date-filter me-3"
                          onChange={handleFilterMonthly}
                          value={filterMonthly.month}
                        />
                        {/* <Col xs={3}>
                          <Select
                            placeholder="Select restaurant"
                            options={[
                              { value: "", label: "All" },
                              { value: "hanamaruken", label: "hanamaruken" },
                              { value: "ettas", label: "ETTAS" },
                            ]}
                            onChange={(e) => setRestoType(e)}
                            defaultValue={restoType}
                          />
                        </Col> */}
                      </>
                    )}
                  </div>
                  <Row>
                    <Col>
                      <span className="align-middle mt-4 bold-font">
                        <h5>TOTAL TRANSACTIONS: {monthlyTransactionNo}</h5>
                      </span>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <span className="align-middle bold-font">
                        <h5>
                          TOTAL SALES: PHP{" "}
                          {numberWithCommas(
                            parseFloat(monthlyGrandTotal).toFixed(2)
                          )}
                        </h5>
                      </span>
                    </Col>
                  </Row>
                  <Table
                    tableHeaders={[
                      "DATE",
                      "SI. FROM",
                      "SI. TO",
                      "NET VATABLE SALES",
                      "VAT EXEMPT SALES",
                      "ZERO-RATED",
                      "GROSS VAT SALES",
                      "TOTAL VAT",
                      "NET VAT",
                      "PWD DISC.",
                      "SENIOR DISC.",
                      "OTHER DISC.",
                      "TOTAL DISC.",
                      "VAT EXEMPT",
                      "TOTAL TAX",
                      "GRAND TOTAL",
                    ]}
                    headerSelector={[
                      "sales_date",
                      "or_from",
                      "or_to",
                      "total_vat_sales",
                      "total_vat_exempt_sales",
                      "total_zero_rated_sales",
                      "total_sales",
                      "total_vat",
                      "net_vat",
                      "pwd_discount",
                      "senior_discount",
                      "other_discount",
                      "total_discount",
                      "total_vat_exemption",
                      "total_tax",
                      "grand_total",
                    ]}
                    tableData={monthlySales}
                    showLoader={showLoader}
                  />
                </Row>
              </div>
            </Tab>
            <Tab eventKey="daily" title="daily">
              <div>
                <Row className="my-1 mb-3">
                  <div className="my-2 px-4 PO-filters d-flex">
                    {getRole() !== "2" && (
                      <>
                        <Form.Select
                          size="sm"
                          name="type"
                          className="date-filter me-3"
                          onChange={handleFilter}
                          value={filter.type}
                        >
                          <option value="" hidden selected>
                            Select Type
                          </option>
                          <option value="">All</option>
                          <option value="cash">Cash</option>
                          <option value="card">Card</option>
                          <option value="gcash">Gcash</option>
                          <option value="maya">Maya</option>
                          <option value="foodpanda">Food Panda</option>
                          <option value="grab">Grab</option>
                          <option value="qrph">QR Ph</option>
                        </Form.Select>
                        <Col xs={3} className="me-1">
                          <RangePicker
                            onChange={(e) => {
                              if (e) {
                                setFilter((prev) => ({
                                  ...prev,
                                  date_from: e[0].format("YYYY-MM-DD"),
                                  date_to: e[1].format("YYYY-MM-DD"),
                                }));
                              } else {
                                setFilter((prev) => ({
                                  ...prev,
                                  date_from: dateToday,
                                  date_to: dateToday,
                                }));
                              }
                            }}
                            placeholder={[dateToday, dateToday]}
                            className="w-100"
                          />
                        </Col>
                        {/* <Col xs={3}>
                          {" "}
                          <Select
                            placeholder="Select restaurant"
                            options={[
                              { value: "", label: "All" },
                              { value: "hanamaruken", label: "hanamaruken" },
                              { value: "ettas", label: "ETTAS" },
                            ]}
                            onChange={(e) => setRestoType(e)}
                            defaultValue={restoType}
                          />
                        </Col> */}
                      </>
                    )}
                  </div>
                  <Row>
                    <Col>
                      <span className="align-middle mt-4 bold-font">
                        <h5>TOTAL TRANSACTIONS: {dailyTransactionNo}</h5>
                      </span>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <span className="align-middle bold-font">
                        <h5>
                          TOTAL SALES: PHP{" "}
                          {numberWithCommas(
                            parseFloat(overAllSales).toFixed(2)
                          )}
                        </h5>
                      </span>
                    </Col>
                  </Row>
                  <Table
                    tableHeaders={[
                      "DATE",
                      "NET VATABLE SALES",
                      "VAT EXEMPT SALES",
                      "ZERO-RATED",
                      "GROSS VAT SALES",
                      "TOTAL VAT",
                      "PWD DISC.",
                      "SENIOR DISC.",
                      "OTHER DISC.",
                      "TOTAL DISC.",
                      "VAT EXEMPT",
                      "TOTAL TAX",
                      "GRAND TOTAL",
                    ]}
                    headerSelector={[
                      "sales_date",
                      "vat_sales",
                      "vat_exempt",
                      "zero_rated",
                      "total_sales",
                      "vat_amount",
                      "pwd_discount",
                      "senior_discount",
                      "other_discount",
                      "discount",
                      "vat_exemption",
                      "total_tax",
                      "total_amount",
                    ]}
                    tableData={sales}
                    showLoader={showLoader}
                  />
                </Row>
              </div>
            </Tab>
          </Tabs>
        </Row>
        <div style={{ display: "none" }}>
          <PrintReportReceipts
            ref={componentRefSummary}
            name={"Daily Sales Report"}
            data={exportData}
            filter={filter}
          />
        </div>

        {/* CSV COMPONENT OF DAILY SALES REPORT*/}
        <div style={{ display: "none" }}>
          <Row>
            <div className="row" ref={componentRef}>
              <Row>
                <Col className="d-flex justify-content-center print-text-category">
                  <label>{window.company_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text-category">
                  <label>{window.company_address}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text-category">
                  <label>{window.company_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text-category">
                  <label>{window.company_min}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text-category">
                  <label>{window.company_sn}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text-category">
                  <label>{window.company_ptu_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center print-text-category">
                  <label>{window.issued_date}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center print-text-category">
                  <label>{window.issued_date}</label>
                </Col>
              </Row>
              <table className="table table-bordered left ms-5 ">
                <thead></thead>
                <tbody>
                  <tr>
                    <th colSpan={3}>
                      DAILY SALES REPORTS
                      {/* {restoType !== "" ? ` (${restoType.toUpperCase()})` : ""} */}
                    </th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE FROM: {dateFormat(new Date(filter.date_from))}
                    </th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE TO: {dateFormat(new Date(filter.date_to))}
                    </th>
                  </tr>
                  <tr>
                    <th>DATE</th>
                    <th>NET VATABLE SALES</th>
                    <th>VAT EXEMPT SALES</th>
                    <th>ZERO-RATED</th>
                    <th>GROSS VAT SALESS</th>
                    <th>TOTAL VAT</th>
                    <th>PWD DISCOUNT</th>
                    <th>SENIOR DISCOUNT</th>
                    <th>OTHER DISCOUNT</th>
                    <th>TOTAL DISCOUNT</th>
                    <th>VAT EXEMPT</th>
                    <th>GRAND TOTAL</th>
                  </tr>
                  {sales.map((data) => {
                    return (
                      <tr>
                        <td>{data.sales_date}</td>
                        <td>{data.vat_sales} </td>
                        <td>{data.vat_exempt} </td>
                        <td>
                          {
                            data.zero_rated !== "0.00"
                              ? data.zero_rated
                              : "0.00"
                          }{" "}
                        </td>
                        <td>{data.total_sales} </td>
                        <td>{data.vat_amount} </td>
                        <td>{data.pwd_discount} </td>
                        <td>{data.senior_discount} </td>
                        <td>{data.other_discount} </td>
                        <td>{data.discount} </td>
                        <td>{data.vat_exemption} </td>
                        <td>{data.total_amount} </td>
                      </tr>
                    );
                  })}

                  <tr>
                    <br></br>
                  </tr>
                  <tr>
                    <td></td>
                    <td>{numberFormat(overVatSales)} </td>
                    <td>
                      {numberFormat(parseFloat(overVatExemptSales).toFixed(2))}{" "}
                    </td>
                    <td>
                      {numberFormat(parseFloat(overZeroRatedSales).toFixed(2))}{" "}
                    </td>
                    <td>
                      {numberFormat(parseFloat(overAllTotalSales).toFixed(2))}{" "}
                    </td>
                    <td>{numberFormat(parseFloat(totalVat).toFixed(2))} </td>
                    <td>
                      {numberFormat(parseFloat(pwdDiscountData).toFixed(2))}{" "}
                    </td>
                    <td>
                      {numberFormat(parseFloat(seniorDiscountData).toFixed(2))}{" "}
                    </td>
                    <td>
                      {numberFormat(parseFloat(otherDiscountData).toFixed(2))}
                    </td>
                    <td>
                      {numberFormat(parseFloat(totalDiscountData).toFixed(2))}{" "}
                    </td>
                    <td>
                      {numberFormat(parseFloat(overExemptionSales).toFixed(2))}{" "}
                    </td>
                    <td>{numberFormat(overAllSales)} </td>
                  </tr>

                  <tr></tr>
                </tbody>
              </table>
            </div>
          </Row>
        </div>
        {/* CSV COMPONENT */}
        <div className="hide-from-screen">
          <div className="row" ref={componentRefMonthly}>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-sales">
                {window.company_name}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-sales">
                {window.company_address}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-sales">
                {" "}
                {window.company_vat_reg_tin}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-sales">
                {window.company_min}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-sales">
                {window.company_sn}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-sales">
                {window.company_ptu_no}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-sales">
                {window.issued_date}
              </label>
            </div>
            <table className="table table-bordered left ms-5 ">
              <thead></thead>
              <tbody>
                <tr>
                  <th colSpan={3}>
                    MONTHLY SALES REPORT{" "}
                    {/* {restoType !== "" ? ` (${restoType.toUpperCase()})` : ""} */}
                  </th>
                </tr>
                <tr>
                  <th colSpan={3}>MONTH OF: {filterMonthly.month}</th>
                </tr>
                <tr>
                  <th>DATE</th>
                  <th>SI. FROM</th>
                  <th>SI. TO</th>
                  <th>NET VATABLE SALES</th>
                  <th>VAT EXEMPT SALES</th>
                  <th>ZERO-RATED</th>
                  <th>GROSS VAT SALES</th>
                  <th>TOTAL VAT</th>
                  <th>NET VAT</th>
                  <th>VAT EXEMPT</th>
                  <th>PWD DISCOUNT</th>
                  <th>SENIOR DISCOUNT</th>
                  <th>OTHER DISCOUNT</th>
                  <th>TOTAL DISCOUNT</th>
                  {/* <th>TOTAL TAX</th> */}
                  <th>GRAND TOTAL</th>
                </tr>
                {monthlySales.map((data) => {
                  return (
                    <tr>
                      <td>{data.sales_date}</td>
                      <td>{data.or_from}</td>
                      <td>{data.or_to}</td>
                      <td>{data.total_vat_sales} </td>
                      <td>{data.total_vat_exempt_sales} </td>
                      <td>{data.total_zero_rated_sales} </td>
                      <td>{data.total_sales} </td>
                      <td>{data.total_vat} </td>
                      <td>{data.net_vat} </td>
                      <td>{data.total_vat_exemption} </td>
                      <td>{data.pwd_discount} </td>
                      <td>{data.senior_discount} </td>
                      <td>{data.other_discount} </td>
                      <td>{data.total_discount} </td>
                      {/* <td>{data.total_tax} </td> */}
                      <td>{data.grand_total} </td>
                    </tr>
                  );
                })}

                <tr>
                  <br></br>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    {" "}
                    {numberFormat(parseFloat(monthlyTotalVat).toFixed(2))}
                  </td>
                  <td>
                    {" "}
                    {numberFormat(parseFloat(monthlyTotalVatExempt).toFixed(2))}
                  </td>
                  <td>
                    {" "}
                    {numberFormat(parseFloat(monthlyTotalZeroRated).toFixed(2))}
                  </td>
                  <td>
                    {" "}
                    {numberFormat(parseFloat(monthlyTotalSales).toFixed(2))}
                  </td>
                  <td> {numberFormat(parseFloat(monthlyVat).toFixed(2))}</td>
                  <td>
                    {" "}
                    {numberFormat(parseFloat(monthlyNetVat).toFixed(2))}
                  </td>
                  <td>
                    {" "}
                    {numberFormat(parseFloat(monthlyExemption).toFixed(2))}
                  </td>
                  <td>
                    {" "}
                    {numberFormat(
                      parseFloat(pwdDiscountDataMonthly).toFixed(2)
                    )}
                  </td>
                  <td>
                    {" "}
                    {numberFormat(
                      parseFloat(seniorDiscountDataMonthly).toFixed(2)
                    )}
                  </td>
                  <td>
                    {" "}
                    {numberFormat(
                      parseFloat(otherDiscountDataMonthly).toFixed(2)
                    )}
                  </td>
                  <td>
                    {" "}
                    {numberFormat(parseFloat(monthlyDiscount).toFixed(2))}
                  </td>
                  {/* <td > {numberFormat(parseFloat(monthlyTotalTax).toFixed(2))}</td> */}
                  <td>
                    {" "}
                    {numberFormat(parseFloat(monthlyGrandTotal).toFixed(2))}
                  </td>
                </tr>
                <tr></tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* PRINT PDF COMPONENT */}
        <div className="hide-from-screen">
          <div ref={divId}>
            <div className="d-flex justify-content-center">
              <div className="print-receipt">
                <Row className="">{window.company_name}</Row>
                <Row className="smaller-text">{window.company_address}</Row>
                <Row className="">{window.company_vat_reg_tin}</Row>
                <Row className="">{window.company_min}</Row>
                <Row className="">{window.company_sn}</Row>
                <Row className="smaller-text">{window.company_ptu_no}</Row>
                <Row className="">{window.company_issued_date}</Row>
                <div className="d-flex row justify-content-left mt-2">
                  <div className="col">
                    <label className="d-flex row justify-content-left print-text-sales">
                      <strong>
                        {/* {restoType !== "" ? `${restoType.toUpperCase()}` : ""} */}
                      </strong>
                    </label>
                  </div>
                </div>
                <div className="d-flex row justify-content-left">
                  <div className="col">
                    <label className="d-flex row justify-content-left print-text-sales">
                      <strong>
                        {selectMonthly === "monthly"
                          ? "MONTHLY SALES REPORT" +
                            "" +
                            "-" +
                            "" +
                            filter.type.toUpperCase()
                          : "DAILY SALES REPORT" +
                            "" +
                            "-" +
                            "" +
                            filter.type.toUpperCase()}
                      </strong>
                    </label>
                  </div>
                  <div className="col d-flex justify-content-end">
                    <label className=" print-text-sales">
                      <strong>{formatDateSeconds(new Date())}</strong>
                    </label>
                  </div>
                </div>
                <hr />
                <div className="d-flex row justify-content-center">
                  <div className="col">
                    <label className="print-text-sales">DATE</label>
                  </div>
                  <div className="col d-flex justify-content-end">
                    <label className="print-text-sales">TOTAL</label>
                  </div>
                </div>
                {selectMonthly === "monthly"
                  ? monthlySales?.map((data) => {
                      return (
                        <div className="d-flex row justify-content-center">
                          <div className="col">
                            <label className="print-text-sales">
                              {data.sales_date}
                            </label>
                          </div>
                          <div className="col d-flex justify-content-end">
                            <label className="print-text-sales">
                              {numberWithCommas(
                                parseFloat(data?.grand_total).toFixed(2)
                              )}
                            </label>
                          </div>
                        </div>
                      );
                    })
                  : salesDaily?.map((data) => {
                      return (
                        <div className="d-flex row justify-content-center">
                          <div className="col">
                            <label className="print-text-sales">
                              {data.sales_date}
                            </label>
                          </div>
                          <div className="col d-flex justify-content-end">
                            <label className="print-text-sales">
                              {numberWithCommas(
                                parseFloat(data.total_sales).toFixed(2)
                              )}
                            </label>
                          </div>
                        </div>
                      );
                    })}
                <hr />
                {selectMonthly === "monthly" ? (
                  <div className="d-flex row justify-content-center">
                    <div className="col">
                      <label className="print-text-sales">
                        <strong>GRAND TOTAL</strong>
                      </label>
                    </div>
                    <div className="col d-flex justify-content-end">
                      <label className="print-text-sales">
                        <strong>
                          {numberWithCommas(
                            parseFloat(monthlyGrandTotal).toFixed(2)
                          )}
                        </strong>
                      </label>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex row justify-content-center">
                    <div className="col">
                      <label className="print-text-sales">
                        <strong>GRAND TOTAL</strong>
                      </label>
                    </div>
                    <div className="col d-flex justify-content-end">
                      <label className="print-text-sales">
                        <strong>
                          {numberWithCommas(
                            parseFloat(overAllSales).toFixed(2)
                          )}
                        </strong>
                      </label>
                    </div>
                  </div>
                )}
                <Row className="mt-4">{window.myt_name}</Row>
                <Row className="smaller-text">{window.myt_address1}</Row>
                <Row className="">{window.myt_address2}</Row>
                <Row className="">{window.myt_vat_reg_tin}</Row>
                <Row className="">{window.myt_min}</Row>
                <Row className="">{window.myt_sn}</Row>
                <Row className="">{window.myt_ptu_no}</Row>
                <Row className="">{window.myt_issued_date}</Row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MytFooter/>
      <div style={{ display: "none" }}>
        <PrintHourly
          ref={componentRefHourly}
          data={hourlyData}
          // restoType={restoType}
        />
      </div>
    </div>
  );
}
export default Sales;
